// extracted by mini-css-extract-plugin
export var button = "_o4-2";
export var card = "_o4-0";
export var closeButtonContainer = "_o4-3";
export var iconContainer = "_o4-1";